import React from "react";
import HeaderImage from "../HeaderImage";
import { motion } from "framer-motion";
import { CircleDot } from "lucide-react";
import HoverLinkPreview from "../HoverLinkPreview";
// import { ReactTinyLink } from 'react-tiny-link';


// const workshopActivities = [
//   {
//     title: "Research Data Management (RDM) Workshop",
//     subTitle: `<span>– Principles, Policies, and Practices</span>`,
//     date: "November 2023",
//     link: "https://indico.wacren.net/event/176/",
//     description: `<p className="mb-4">
//       Held during the 19th RUFORUM AGM in Yaoundé, Cameroon, this workshop focused on strengthening RDM and promoting open agricultural data sharing in Africa.
//       </p>`,
//     image: "/assets/images/workshop/LIBSENSE_RUFORUM.jpg",
//     reverse: false,
//   },
//   {
//     title: "Continental SURVEY",
//     subTitle: `<span>– Needs Assessment Questionnaire for the Development of an Open Data Repository</span>`,
//     date: "September 2023",
//     description:
//       " Aimed to gather input on the requirements for an open data repository within the RUFORUM community.",
//     image: "/assets/images/workshop/survey.webp",
//     reverse: true,
//   },
//   {
//     title: "LIBSENSE-RUFORUM Webinar on Open Science and RDM",
//     date: "February 2023",
//     subTitle: ``,
//     link: "https://indico.wacren.net/event/230/",
//     description: ` <p className="mb-4">
//                     This
//                     <a
//                       href="https://survey.wacren.net/index.php/516664"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-primary"
//                     >
//                       webinar
//                     </a>
//                     educated participants on open science and RDM concepts, setting the stage for the needs assessment survey.
//                   </p>`,
//     image: "/assets/images/workshop/Workshop-Webinar-2.jpg",
//     reverse: false,
//   },
//   {
//     title: "Workshop on Needs Assessment Validation for Open Data Repository",
//     subTitle: ``,
//     date: "December 2022",
//     link: "https://indico.wacren.net/event/231/",
//     description: `   <p className="mb-4">
//                    Held in Harare, Zimbabwe, the  <a
//                       href="https://ruforum.org/AGM2023/sites/default/files/Concept%20note%20RUFORUM-LIBSENSE%20RDM.pdf"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-primary"
//                     >
//                       workshop
//                     </a> validated the needs assessment tool and emphasised raising awareness about key concepts in the survey.
//                   </p>`,
//     image: "/assets/images/workshop/WORKSHOP-UPDATE.jpg",
//     reverse: true,
//   },
// ];

const workshopActivities = [
  {
    title: "Research Data Management (RDM) Workshop",
    subTitle: `<span>– Principles, Policies, and Practices</span>`,
    date: "November 2023",
    link: "https://indico.wacren.net/event/176/",
    description: `<p class="mb-4">
      Held during the 19th RUFORUM AGM in Yaoundé, Cameroon, this workshop focused on strengthening RDM and promoting open agricultural data sharing in Africa.
      </p>`,
    image: "/assets/images/workshop/LIBSENSE_RUFORUM.jpg",
    reverse: false,
  },
  {
    title: "LIBSENSE-RUFORUM Webinar on Open Science and RDM",
    date: "February 2023",
    subTitle: ``,
    link: "https://indico.wacren.net/event/230/",
    description: `<p class="mb-4">
      This <a href="https://survey.wacren.net/index.php/516664" target="_blank" rel="noopener noreferrer" class="text-primary">webinar</a> educated participants on open science and RDM concepts, setting the stage for the needs assessment survey.
    </p>`,
    image: "/assets/images/workshop/Workshop-Webinar-2.jpg",
    reverse: false,
  },
  {
    title: "Workshop on Needs Assessment Validation for Open Data Repository",
    subTitle: ``,
    date: "December 2022",
    link: "https://indico.wacren.net/event/231/",
    description: `<p class="mb-4">
      Held in Harare, Zimbabwe, the <a href="https://ruforum.org/AGM2023/sites/default/files/Concept%20note%20RUFORUM-LIBSENSE%20RDM.pdf" target="_blank" rel="noopener noreferrer" class="text-primary">workshop</a> validated the needs assessment tool and emphasised raising awareness about key concepts in the survey.
    </p>`,
    image: "/assets/images/workshop/WORKSHOP-UPDATE.jpg",
    reverse: true,
  },
];


const activities = [
  {
    title: `<p><strong>Developed Technical Specifications</strong> for the open data repository</p>`,
    date: "November 2024",
  },
  {
    title: `<p><strong>Policy Survey:</strong> Shared with the RUFORUM community to address policy issues</p>`,
    date: "September 2024",
  },
  {
    title: `<p><strong>First Stakeholder Advisory Group (SAG) Meeting</strong></p>`,
    date: "September 2024",
  },
  {
    title: `<p><strong>Policy Guidelines:</strong> Drafts of data sharing and data protection policies developed</p>`,
    date: "August 2024",
  },
  {
    title: `<p><strong>Establishment of the Stakeholder Advisory Group (SAG) </strong></p>`,
    date: "August 2024",
  },
];
const SectionHeading = ({ children }: { children: React.ReactNode }) => (
  <motion.h3
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    className="text-2xl font-semibold text-foreground mb-6"
  >
    {children}
  </motion.h3>
);

// const wrapLinksWithPreview = (htmlString: string) => {
//   const regex = /<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/g;
//   let result = [];
//   let lastIndex = 0;

//   // Iterate through all links in the description
//   let match;
//   while ((match = regex.exec(htmlString))) {
//     // Add the content before the link
//     if (match.index > lastIndex) {
//       result.push(htmlString.slice(lastIndex, match.index));
//     }

//     // Wrap the <a> tag in the HoverLinkPreview component
//     const [_, url, text] = match;
//     result.push(
//       <HoverLinkPreview key={url} url={url}>
//         <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
//           {text}
//         </a>
//       </HoverLinkPreview>
//     );

//     lastIndex = regex.lastIndex;
//   }

//   // Add the rest of the description after the last link
//   if (lastIndex < htmlString.length) {
//     result.push(htmlString.slice(lastIndex));
//   }

//   return result;
// };

const RuforumThirdPage: React.FC = () => {
  const groupedWorkshops = workshopActivities.reduce(
    (acc: Record<string, typeof workshopActivities>, event) => {
      const year = event.date.split(" ").pop() || "Unknown"; // extract year or fallback to "Unknown"
      acc[year] = acc[year] ? [...acc[year], event] : [event];
      return acc;
    },
    {}
  );

  return (
    <>
      <HeaderImage image="/assets/images/backgrounds/collab.jpg" />

      <section className="container mx-auto px-4 md:px-8">
        <motion.h2
          className="mt-10 text-xxl font-bold text-foreground mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          LIBSENSE-RUFORUM Partnership
        </motion.h2>

        <motion.div
          className="space-y-4 text-sm text-foreground leading-relaxed"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <p className="mt-4">
            In 2021, the{" "}
            <HoverLinkPreview url="https://wacren.net/en/">
              West and Central African Research and Education Network (WACREN)
              </HoverLinkPreview>{" "}
            on behalf of LIBSENSE, signed a three-year Memorandum of
            Understanding (MoU) with the Regional Universities Forum for
            Capacity Building in Agriculture ({" "}
          
            <HoverLinkPreview url="https://www.ruforum.org">
              RUFORUM
            </HoverLinkPreview>
            ) to advance scientific and scholarly communication across Africa.
            This collaboration, part of the{" "}
           
            <HoverLinkPreview url="https://africaconnect3.net/">

              AfricaConnect3
            </HoverLinkPreview>
            {" "}
            project, focuses on creating modern platforms for agricultural
            research data sharing and open access publishing.
          </p>

          <p>
            Following a successful initial phase, the{" "}
          
               <HoverLinkPreview url="https://wacren.net/en/news/ruforum-and-wacren-renew-cooperation-to-expand-open-science-and-digital-services-in-africa/">
              MoU was renewed in 2023

               </HoverLinkPreview>
            {" "}
            for another two years. The primary goals of this ongoing partnership
            include building capacity in research data management (RDM),
            developing open access repositories (OARs), promoting open science
            policies, and boosting the impact of research within Africa's
            agricultural sector.
          </p>
          <p>
            Through this collaboration, LIBSENSE and RUFORUM have undertaken key
            initiatives, including conducting a needs assessment survey to
            identify the requirements for an open data repository and inform its
            design and development.
          </p>
        </motion.div>

        {/* Activities Section */}
        <section className="my-16">
          <SectionHeading>Key Activities and Milestones</SectionHeading>
          <h3 className="text-xl font-bold text-primary mb-6 border-b pb-2">
            2024
          </h3>
          <motion.ul
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.8 }}
            className="relative border-l border-primary pl-6 space-y-8"
          >
            {activities.map((activity, index) => (
              <li key={index} className="relative">
                <div className="absolute -left-5 top-1 text-primary">
                  <CircleDot size={20} />
                </div>
                <div
                  className="activity-content"
                  dangerouslySetInnerHTML={{ __html: activity.title }}
                ></div>
                <time className="block text-sm text-muted">
                  {activity.date}
                </time>
              </li>
            ))}
          </motion.ul>
        </section>

        {/* Workshop Section */}
        <section className="mt-20">
          <SectionHeading>Workshops & Webinars</SectionHeading>

          {Object.entries(groupedWorkshops)
            .sort((a, b) => parseInt(b[0]) - parseInt(a[0])) // sort years descending
            .map(([year, events]) => (
              <div key={year} className="mb-12">
                <h3 className="text-xl font-bold text-primary mb-6 border-b pb-2">
                  {year}
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
                  {events.map((event, index) => (
                    <motion.div
                      key={index}
                      className="relative bg-card rounded-2xl shadow-lg p-6 flex flex-col gap-2 border border-border hover:shadow-xl transition-shadow duration-300 group"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      viewport={{ once: true }}
                    >
                      {/* Hover preview image */}
                      {event.image && (
                        <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <img
                            src={event.image}
                            alt="Preview"
                            className="w-32 h-20 object-cover rounded-lg shadow-md border"
                          />
                        </div>
                      )}

                      {/* Title */}
                      <div className="flex items-center gap-2 font-semibold text-lg text-primary">
                        {/* <FileText className="w-5 h-5 text-muted-foreground" /> */}
                        
                        <div className="flex items-center gap-2 font-semibold text-lg text-primary">
  {event.link ? (
    <HoverLinkPreview url={event.link}>
      {event.title}
    </HoverLinkPreview>
  ) : (
    event.title
  )}
</div>

                      </div>

                      {/* Subtitle */}
                      {event.subTitle && (
                        <div
                          className="text-sm text-muted-foreground"
                          dangerouslySetInnerHTML={{ __html: event.subTitle }}
                        />
                      )}

                      {/* Date */}
                      <div className="flex items-center text-sm text-muted-foreground gap-1">
                        {/* <CalendarDays className="w-4 h-4" /> */}
                        {event.date}
                      </div>

                      {/* Description */}
                      <div
                        className="news-content"
                        dangerouslySetInnerHTML={{ __html: event.description }}
                      />
                       {/* <div className="text-xs text-gray-600">
                {wrapLinksWithPreview(event.description)}
              </div> */}
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
        </section>
      </section>
    </>
  );
};

export default RuforumThirdPage;
